import { apiClient } from "@/lib/api/client";
import type {
  EffectivePermissionsDto,
  PermissionManagedRole,
  PermissionsMatrixDto,
  RolePermissionMatrixDto,
  RolePermissionsUpdateBody,
} from "@/lib/api/types/enterprise";

export async function getPermissionsMatrix(): Promise<PermissionsMatrixDto> {
  const { data } = await apiClient.get<PermissionsMatrixDto>("/permissions");
  return data;
}

export async function getMyEffectivePermissions(): Promise<EffectivePermissionsDto> {
  const { data } = await apiClient.get<EffectivePermissionsDto>("/permissions/me");
  return data;
}

export async function updateRolePermissions(
  role: PermissionManagedRole,
  body: RolePermissionsUpdateBody,
): Promise<RolePermissionMatrixDto> {
  const { data } = await apiClient.put<RolePermissionMatrixDto>(`/permissions/${role}`, body);
  return data;
}
